var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextColorBlue = function SvgTextColorBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 0.5,
    stroke: "#E4E9F2",
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07733 17H7.44664L11.1107 6.81818H12.8856L16.5496 17H14.9189L12.0404 8.66761H11.9608L9.07733 17ZM9.35076 13.0128H14.6405V14.3054H9.35076V13.0128Z",
    fill: "#2D54A8"
  })));
};
export default SvgTextColorBlue;